"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpandedLicenseItemButtons = void 0;
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const Button_1 = __importDefault(require("../../../common/js/atoms/Button"));
const GlobalModal_1 = require("../../../common/js/components/GlobalModal");
const ScopeGuard_1 = __importDefault(require("../../../common/js/components/security/ScopeGuard"));
const AuthorizationScopes_1 = __importDefault(require("../../../common/js/enums/AuthorizationScopes"));
const ButtonVariant_1 = __importDefault(require("../../../common/js/enums/ButtonVariant"));
const LicenseState_1 = require("../../../common/js/enums/LicenseState");
const Zupicons_1 = __importDefault(require("../../../common/js/enums/Zupicons"));
const string_1 = require("../../../common/js/helper/string");
const table_1 = require("../../../common/js/helper/table");
const translation_1 = require("../../../common/js/helper/translation");
const useLicenseState_1 = require("../../hooks/useLicenseState");
const ChangeLicenseContactModal_1 = __importDefault(require("../ChangeLicenseContactModal"));
const ChangeUsageInformationModal_1 = __importDefault(require("../ChangeUsageInformationModal"));
const LicenseActivationWorkflowButton_1 = require("./LicenseActivationWorkflowButton");
exports.ExpandedLicenseItemButtons = (0, mobx_react_1.observer)(({ license }) => {
    const { state, isFetching } = (0, useLicenseState_1.useLicenseState)(license);
    const externalId = (0, table_1.mustTextBeShortened)(license) ? (0, string_1.ellipsis)(license.externalId, 5) : license.externalId;
    return (react_1.default.createElement("div", { className: "znd-assets-table-sub__buttons" },
        react_1.default.createElement("div", { className: "znd-assets-table-sub__button-wrapper" },
            react_1.default.createElement(LicenseActivationWorkflowButton_1.LicenseActivationWorkflowButton, { license: license })),
        react_1.default.createElement(ScopeGuard_1.default, { scopes: [AuthorizationScopes_1.default.LICENSE_UPDATE] },
            react_1.default.createElement("div", { className: "znd-assets-table-sub__button-wrapper" },
                react_1.default.createElement(Button_1.default, { className: "justify-content-center", onClick: () => {
                        (0, GlobalModal_1.showModal)({
                            component: ChangeUsageInformationModal_1.default,
                            props: {
                                data: license,
                                externalId: externalId,
                            },
                        });
                    }, text: (0, translation_1.t)('myassets.software.btn.edit_usage.title') ?? '', variant: ButtonVariant_1.default.secondary, disabled: state === LicenseState_1.LicenseState.Inactive || isFetching, loading: isFetching, icon: Zupicons_1.default.shredder })),
            react_1.default.createElement("div", { className: "znd-assets-table-sub__button-wrapper" },
                react_1.default.createElement(Button_1.default, { className: "justify-content-center", onClick: () => {
                        (0, GlobalModal_1.showModal)({
                            component: ChangeLicenseContactModal_1.default,
                            props: {
                                data: license,
                                externalId: externalId,
                            },
                        });
                    }, text: (0, translation_1.t)('myassets.software.btn.edit_license_contact.title') ?? '', variant: ButtonVariant_1.default.secondary, disabled: state === LicenseState_1.LicenseState.Inactive || isFetching, loading: isFetching, icon: Zupicons_1.default.userEdit })))));
});
